import Layout from "views/Feedback/Layout";
import { Flags } from "configs/featureFlags";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import UserReview from "views/UserReview";
import UserReviewV2 from "views/UserReviewV2";
import Skeleton from "react-loading-skeleton";

const UserReviewFeatureFlagRouter = () => {
  const {
    flagEnabled: userReviewV2Enabled,
    isLoading,
    isFetching,
  } = useFeatureFlag(Flags.UserReviewV2);

  if (isLoading || isFetching) {
    return (
      <Layout
        style={{
          minHeight: "100vh",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Skeleton height={20} width={300} />
        <Skeleton height={10} width={400} />
      </Layout>
    );
  }

  if (userReviewV2Enabled) {
    return <UserReviewV2 />;
  }

  return <UserReview />;
};

export default UserReviewFeatureFlagRouter;
